import { StoreSimpleListType } from '@smx-ui-model/types';

export const storeSimpleList: StoreSimpleListType = {
    measureUnit: [
        {
            id: 'METER',
            value: 'meter',
        },
        {
            id: 'FEET',
            value: 'feet',
        },
    ],
};
